import { render } from "./ModalRedefinirSenha.vue?vue&type=template&id=20d3920c&scoped=true"
import script from "./ModalRedefinirSenha.vue?vue&type=script&lang=js"
export * from "./ModalRedefinirSenha.vue?vue&type=script&lang=js"

import "./ModalRedefinirSenha.vue?vue&type=style&index=0&id=20d3920c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d3920c"]])

export default __exports__